import { DateUtils } from 'core/utils';
import { Input, InputProps } from './Input';

import * as React from 'react';
import { FieldValues, Path } from 'react-hook-form';

export type DateInputRef = HTMLInputElement;

export interface DateInputProps<T extends FieldValues, TPath extends Path<T>> extends Omit<InputProps<T, TPath>, 'type' | 'formatFieldValue' | 'formatChangeEventValue'> {
	type?: 'date' | 'datetime-local'
}

const isDate = (value: unknown) => {
	return value instanceof Date;
};

export const DateInput = <T extends FieldValues, TPath extends Path<T>>(props: DateInputProps<T, TPath>) => {

	const { type, ...rest } = props;
	const formatFieldValue = React.useCallback((value: Date | string): string => {
		// La primera vez que se extrae el valor del objeto es un Date, luego ya siempre se trabaja con strings
		if (isDate(value))
			return type === 'datetime-local' ? DateUtils.formatDate(value, 'yyyy-MM-dd\'T\'HH:mm') : DateUtils.formatDate(value, 'yyyy-MM-dd');
		return value ?? '';
	}, [type]);

	return (
		<Input
			type={type ?? 'date'}
			{...rest}
			min={type === 'datetime-local' ? '1753-01-01T00:00' : '1753-01-01'}
			max={type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31'}
			formatFieldValue={formatFieldValue}
		/>
	);
};
